/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import RejectModal from '../components/RejectModal';
import PermitForm from '../components/PermitForm';
import BusinessActivity from '../components/BusinessActivity';
import Requirements from '../components/Requirements';
import FixTax from '../components/FixTax';
import OtherFees from '../components/OtherFees';
import BusinessTransactionList from '../components/BusinessTransactionList';
import PrintTaxOrderModal from '../components/PrintTaxOrderModal';
import PrintMayorsPermitModal from '../components/PrintMayorsPermitModal';
import * as actions from '../action';
import * as c from '../constant';

const initMode = {
  businessActivity: 0,
  otherFees: 0,
};

function BusinessTaxContent({
  UpdateData,
  match,
  getBusinessInfo,
  businessInfo,
  isLoading,
  otherFeeList,
  getBusinessFixTaxList,
  businessFixTaxList,
  approveBusiness,
  getBusinessTransactionHistoryList,
  businessTransactionHistoryList,
  computeBusinessActivity,
  computeFixedTax,
  computeOtherFee,
  token,
  adminEmail,
  startAssessment,
}) {
  const setModal = useContext(ModalContext);

  const form = {
    businessActivity: [],
    otherFees: [],
    total_capitalization_tax: 0,
    mayors_fee: 0,
  };
  const [formData, setFormData] = useState(form);
  const [businessActivityData, setBusinessActivityData] = useState([]);
  const [otherFeeData, setOtherFeeData] = useState([]);

  const [activeTab, setActiveTab] = useState(1);
  const [activeBusinessHistory, setActiveBusinessHistory] = useState(0);
  const [mode, setMode] = useState(initMode); // EDIT MODE FOR BA AND OF
  const businessId = match.params.business_Id;
  const firstHistoryIndex = _.get(businessTransactionHistoryList, '0.id');
  const permitType = _.get(businessTransactionHistoryList, '0.attributes.transaction_type');

  const transactionStatus = _.get(
    businessTransactionHistoryList,
    `${activeBusinessHistory}.attributes.transaction_status`,
  ) || '';
  const assessmentStatus = _.get(
    businessTransactionHistoryList,
    '0.attributes.is_start_assessment',
  );
  const requirements = _.get(businessInfo, 'included.businessRequirementFiles') || [];
  const finishedTransactionDetail = _.get(
    businessTransactionHistoryList,
    `${activeBusinessHistory}.included.transactionDetail.attributes`,
    {},
  );
  const currentTransactionId = _.get(
    businessTransactionHistoryList,
    `${activeBusinessHistory}.included.transactionDetail.id`,
  );
  const handlePrintTaxOrderModal = (e) => {
    e.preventDefault();
    if (!_.isEmpty(currentTransactionId) && !_.isEmpty(adminEmail) && !_.isEmpty(token)) {
      setModal({
        isOpen: true,
        content: <PrintTaxOrderModal id={currentTransactionId} email={adminEmail} token={token} />,
        title: 'Print Tax Order',
        modalSize: 'modal-xl',
      });
    }
  };

  const handlePrintMayorsPermit = (e) => {
    e.preventDefault();
    if (!_.isEmpty(currentTransactionId) && !_.isEmpty(adminEmail) && !_.isEmpty(token)) {
      setModal({
        isOpen: true,
        content: (
          <PrintMayorsPermitModal id={currentTransactionId} email={adminEmail} token={token} />
        ),
        title: 'Print Mayor`s Permit',
        modalSize: 'modal-xl',
      });
    }
  };

  const updateData = () => {
    getBusinessInfo(businessId);
    getBusinessTransactionHistoryList(businessId);
    getBusinessFixTaxList(businessId);
  };

  const handleActivePage = index => () => {
    setActiveTab(index);
  };
  const handleMode = (command, location) => {
    switch (location) {
      case 'BA':
        setMode({ ...mode, businessActivity: command });
        break;
      case 'OF':
        setMode({ ...mode, otherFees: command });
        break;
      default:
        break;
    }
  };

  const handleActiveBusinessHistory = index => () => {
    setActiveBusinessHistory(index);
  };

  const handleReject = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <RejectModal id={firstHistoryIndex} businessId={businessId} UpdateData={UpdateData} />
      ),
      title: 'Reject Transaction',
      modalSize: 'modal-md',
    });
  };

  // COMPUTATIONS
  const handleComputeBusinessTax = () => {
    const args = {
      business_activity: businessActivityData.map(item => ({
        line_business: item.line_business || '',
        nature_business: item._nature_business_name || '',
        nature_business_id: item.nature_of_business_id || '',
        capitalization: item.capitalization || 0,
        essential: item.essential || 0,
        non_essential: item.non_essential || 0,
        mayors_fee: item.mayors_fee || 0,
        capitalization_tax: item.capitalization_tax || 0,
      })),
    };
    computeBusinessActivity(args, (data) => {
      const newList = businessActivityData.map((item, i) => ({
        ...item,
        capitalization_tax: _.get(data, `res.res.data.business_activity.${i}.capitalization_tax`),
      }));
      setFormData({
        ...formData,
        total_capitalization_tax: _.get(data, 'res.data.total_capitalization_tax') || 0,
        mayors_fee: _.get(data, 'res.data.total_mayors_fee') || 0,
        businessActivity: newList,
      });
      setBusinessActivityData(newList);
    });
  };

  const handleComputeFixedTax = () => {
    const args = {
      fixed_tax: businessFixTaxList.map(item => ({
        label: item.attributes._fix_tax_name || '',
        per_unit_amount: item.attributes._fix_tax_amount || 0,
        amount: item.attributes._fix_tax_amount || 0,
        quantity: item.attributes.quantity || 0,
      })),
    };
    computeFixedTax(args);
  };

  const handleComputeOtherFee = () => {
    const args = {
      other_fee: otherFeeData.map(item => ({
        name: item.name || '',
        amount: item.amount || 0,
      })),
    };
    computeOtherFee(args);
  };

  // SUBMITION BUILD
  const handleApprove = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to approve ${_.get(businessInfo, 'attributes.business_name')
        || 'this business'}?`,
      () => {
        const transactionId = _.get(businessTransactionHistoryList, '0.id');
        const args = {
          business_activity: businessActivityData.map(item => ({
            line_business: item.line_business || '',
            nature_business: item._nature_business_name || '',
            nature_business_id: item.nature_of_business_id || '',
            capitalization: item.capitalization || 0,
            essential: item.essential || 0,
            non_essential: item.non_essential || 0,
            mayors_fee: item.mayors_fee || 0,
            capitalization_tax: item.capitalization_tax || 0,
          })),

          fixed_tax: businessFixTaxList.map(item => ({
            label: item.attributes._fix_tax_name || '',
            per_unit_amount: item.attributes._fix_tax_amount || 0,
            amount: item.attributes.quantity || 0,
            quantity: item.attributes.quantity || 0,
          })),

          other_fee: otherFeeData.map(item => ({
            name: item.name || '',
            amount: item.amount || 0,
          })),
        };
        approveBusiness(transactionId, args, () => {
          getBusinessTransactionHistoryList(businessId);
          getBusinessInfo(businessId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  const handleSubmitTabs = (data, location) => {
    switch (location) {
      case 'BUSINESS':
        setFormData({
          ...formData,
          businessActivity: data,
        });
        handleMode(0, 'BA');
        handleComputeBusinessTax();
        break;
      case 'OTHER_FEE':
        setFormData({
          ...formData,
          otherFees: data,
        });
        handleMode(0, 'OF');
        handleComputeOtherFee();
        break;
      default:
        break;
    }
  };

  // ARRANGE FORMATS
  const formatBA = (data, isTransactionDone) => {
    if (!_.isEmpty(data)) {
      // UNFINISHED TRANSACTION FORMAT
      if (isTransactionDone === false) {
        const format = data.map(item => ({
          id: _.get(item, 'id'),
          line_business: _.get(item, 'attributes._line_business_name') || '',
          line_of_business_id: _.get(item, 'attributes.line_of_business_id') || '',
          _nature_business_name: _.get(item, 'attributes._nature_business_name') || '',
          nature_of_business_id: _.get(item, 'attributes.nature_of_business_id') || 0,
          capitalization: _.get(item, 'attributes.capitalization') || 0,
          essential: _.get(item, 'attributes.essential') || 0,
          non_essential: _.get(item, 'attributes.non_essential') || 0,
          mayors_fee: 0,
          mayors_fee_label: 0,
          capitalization_tax: 0,
        }));
        return format;
      }
      // FINISHED TRANSACTION FORMAT
      const format = data.map((item, i) => ({
        id: i,
        line_business: _.get(item, 'line_business') || '',
        _nature_business_name: _.get(item, 'nature_business') || '',
        capitalization: _.get(item, 'capitalization') || 0,
        essential: _.get(item, 'essential') || 0,
        non_essential: _.get(item, 'non_essential') || 0,
        mayors_fee_label: _.get(item, 'mayors_fee') || 0,
        capitalization_tax: _.get(item, 'capitalization_tax') || 0,
      }));
      return format;
    }
    return [];
  };

  const formatOF = (data) => {
    if (!_.isEmpty(data)) {
      const format = data.map(item => ({
        id: _.get(item, 'id'),
        name: _.get(item, 'attributes.name'),
        amount: 0,
      }));
      return format;
    }
    return [];
  };

  // ONCHANGE FUNCTIONS
  const handleChangeBA = (row, item) => ({ target }) => {
    setBusinessActivityData(
      businessActivityData.map(x => (x.id === row.id
        ? {
          ...x,
          [item]: target.value,
        }
        : x)),
    );
  };

  const handleSelectedBA = (row, key, key2) => (e) => {
    setBusinessActivityData(
      businessActivityData.map(x => (x.id === row.id
        ? {
          ...x,
          [key]: e.value || '',
          [key2]: e.label || '',
        }
        : x)),
    );
  };

  // to be removed on new update*
  const handleResetMayor = (row, value, label) => {
    setBusinessActivityData(
      businessActivityData.map(x => (x.id === row.id
        ? {
          ...x,
          [value]: 0,
          [label]: 0,
        }
        : x)),
    );
  };
  // to be removed on new update*
  const handleChangeNature = (row, key, key2) => (e) => {
    handleResetMayor(row, 'mayors_fee', 'mayors_fee_label');
    setBusinessActivityData(
      businessActivityData.map(x => (x.id === row.id
        ? {
          ...x,
          [key]: e.value || 0,
          [key2]: e.label || 0,
        }
        : x)),
    );
  };

  const handleChangeOF = (row, item) => ({ target }) => {
    setOtherFeeData(
      otherFeeData.map(x => (x.id === row.id
        ? {
          ...x,
          [item]: target.value,
        }
        : x)),
    );
  };

  useEffect(() => {
    if (!_.isEmpty(businessId)) {
      updateData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(businessId)) {
      updateData();
      setMode(initMode);
    }
  }, [businessId]);

  useEffect(() => {
    // USE FINISHED TRANSACTION DATA IF TRANSACTION IS FINISHED FOR BA
    if (transactionStatus === 'WAITING FOR PAYMENT' || transactionStatus === 'PAID') {
      setFormData({
        ...formData,
        businessActivity: formatBA(_.get(finishedTransactionDetail, 'business_activity', []), true),
        mayors_fee: _.get(finishedTransactionDetail, 'total_mayors_fee', 0),
      });
      setBusinessActivityData(
        formatBA(_.get(finishedTransactionDetail, 'business_activity', []), true),
      );
    } else {
      // IF NOT
      setFormData({
        ...formData,
        businessActivity: formatBA(_.get(businessInfo, 'included.businessActivities', []), false),
      });
      setBusinessActivityData(
        formatBA(_.get(businessInfo, 'included.businessActivities', []), false),
      );
    }
  }, [businessInfo, activeBusinessHistory]);

  useEffect(() => {
    // USE FINISHED TRANSACTION DATA IF TRANSACTION IS FINISHED FOR OF
    if (transactionStatus === 'WAITING FOR PAYMENT' || transactionStatus === 'PAID') {
      const list = _.get(finishedTransactionDetail, 'other_fee', []).map((x, i) => ({
        id: i,
        name: x.name,
        amount: x.amount,
      }));
      setFormData({
        ...formData,
        otherFees: list,
      });
      setOtherFeeData(list);
    } else {
      // IF NOT
      setFormData({
        ...formData,
        otherFees: formatOF(otherFeeList),
      });
      setOtherFeeData(formatOF(otherFeeList));
    }
  }, [otherFeeList, activeBusinessHistory]);

  let afterAssessmentStatus = '';

  const handleGetTransaction = (e) => {
    e.preventDefault();
    const transactionId = _.get(businessTransactionHistoryList, '0.id');
    ConfirmAlert(
      'Are you sure you want to get this transaction for assessment?',
      () => {
        startAssessment(transactionId, () => {
          getBusinessTransactionHistoryList(businessId);
          getBusinessInfo(businessId);
          afterAssessmentStatus = _.get(
            businessTransactionHistoryList,
            '0.attributes.is_start_assessment',
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  return (
    <React.Fragment>
      <div className="container-fluid card-section-content px-0">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        {/* TOP SIDE */}
        <div className="row d-flex align-items-center bg-white m-3 pt-3 rounded">
          {assessmentStatus === 0 && transactionStatus === 'FOR APPEARANCE' ? (
            <div className="col-12">
              <div className="d-flex">
                <button
                  type="button"
                  className="btn btn-black btn-round font-weight-bold px-4 ml-auto"
                  onClick={handleGetTransaction}
                >
                  Start Assessment <i className="fas fa-plus ml-1" />
                </button>
              </div>
            </div>
          ) : (
            ''
          )}
          <div className="col-5 pb-4">
            <h2 className="transaction-company mb-0">
              {_.get(businessInfo, 'attributes.business_name') || '--'}
            </h2>
          </div>
          <div className="col-7 d-flex">
            {transactionStatus === 'WAITING FOR PAYMENT' || transactionStatus === 'PAID' ? (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-black btn-round font-weight-bold px-4 ml-auto mr-1"
                  onClick={handlePrintTaxOrderModal}
                >
                  Print Tax Order <i className="fas fa-print ml-1" />
                </button>
                <button
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4"
                  onClick={handlePrintMayorsPermit}
                >
                  Print Mayor`s Permit <i className="fas fa-print ml-1" />
                </button>
              </React.Fragment>
            ) : (
              ''
            )}
            {((assessmentStatus === 1 || afterAssessmentStatus === 1) && transactionStatus === 'FOR APPEARANCE') ? (
              <React.Fragment>
                <button
                  type="button"
                  onClick={handleApprove}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold  ml-auto px-4 mr-1"
                >
                  Approve
                </button>
                <button
                  type="button"
                  onClick={handleReject}
                  className="btn btn-secondary btn-round font-weight-bold px-4"
                >
                  Reject
                </button>
              </React.Fragment>
            ) : (
              ''
            )}
          </div>
          <div className="col-12 mb-2 pb-3">
            <BusinessTransactionList
              data={businessTransactionHistoryList}
              handleActiveBusinessHistory={handleActiveBusinessHistory}
              activeBusinessHistory={activeBusinessHistory}
            />
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="row mt-4 mx-2">
        <div className="col-12">
          <ul className="nav nav-tabs">
            <li className="nav-item mr-1">
              <button
                type="button"
                className={`btn-blank nav-link active py-2 px-3 border-bottom ${
                  activeTab === 1 ? 'btn-selected font-weight-bold ' : ''
                }`}
                onClick={handleActivePage(1)}
              >
                Business Info
              </button>
            </li>
            <li className="nav-item mr-1">
              <button
                type="button"
                className={`btn-blank nav-link active py-2 px-3 border-bottom ${
                  activeTab === 2 ? 'btn-selected font-weight-bold' : ''
                }`}
                onClick={handleActivePage(2)}
              >
                Business Activity
              </button>
            </li>
            <li className="nav-item mr-1">
              <button
                type="button"
                className={`btn-blank nav-link active py-2 px-3 border-bottom ${
                  activeTab === 3 ? 'btn-selected font-weight-bold' : ''
                }`}
                onClick={handleActivePage(3)}
              >
                Requirements
              </button>
            </li>
            <li className="nav-item mr-1">
              <button
                type="button"
                className={`btn-blank nav-link active py-2 px-3 border-bottom ${
                  activeTab === 4 ? 'btn-selected font-weight-bold' : ''
                }`}
                onClick={handleActivePage(4)}
              >
                Fix Tax
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                className={`btn-blank nav-link active py-2 px-3 border-bottom ${
                  activeTab === 5 ? 'btn-selected font-weight-bold' : ''
                }`}
                onClick={handleActivePage(5)}
              >
                Other Fee
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="right-section-content mx-3 mb-4">
        <div className="container-fluid card-section-content py-4">
          {activeTab === 1 ? <PermitForm data={businessInfo} /> : ''}
          {activeTab === 2 ? (
            <BusinessActivity
              data={_.get(formData, 'businessActivity') || []}
              permitType={permitType || ''}
              mode={mode}
              handleMode={handleMode}
              handleChangeInput={handleChangeBA}
              handleChangeSelect={handleSelectedBA}
              handleChangeNature={handleChangeNature}
              formSubmit={handleSubmitTabs}
              setFormData={setBusinessActivityData}
              formData={businessActivityData}
              transactionStatus={transactionStatus}
            />
          ) : (
            ''
          )}
          {activeTab === 3 ? (
            <Requirements
              formData={formData}
              setFormData={handleSubmitTabs}
              tabList={requirements}
            />
          ) : (
            ''
          )}
          {activeTab === 4 ? (
            <FixTax
              businessId={businessId}
              handleComputeFixedTax={handleComputeFixedTax}
              transactionStatus={transactionStatus}
            />
          ) : (
            ''
          )}
          {activeTab === 5 ? (
            <OtherFees
              data={_.get(formData, 'otherFees') || []}
              mode={mode}
              handleMode={handleMode}
              handleChangeInput={handleChangeOF}
              formSubmit={handleSubmitTabs}
              setFormData={setFormData}
              formData={otherFeeData}
              transactionStatus={transactionStatus}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

BusinessTaxContent.propTypes = {
  UpdateData: PropTypes.instanceOf(Function).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  getBusinessInfo: PropTypes.instanceOf(Function).isRequired,
  businessInfo: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,

  getBusinessTransactionHistoryList: PropTypes.instanceOf(Function).isRequired,
  businessTransactionHistoryList: PropTypes.instanceOf(Object).isRequired,

  approveBusiness: PropTypes.instanceOf(Function).isRequired,
  otherFeeList: PropTypes.instanceOf(Object).isRequired,

  getBusinessFixTaxList: PropTypes.instanceOf(Function).isRequired,
  businessFixTaxList: PropTypes.instanceOf(Object).isRequired,

  computeBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  computeFixedTax: PropTypes.instanceOf(Function).isRequired,
  computeOtherFee: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  token: PropTypes.string.isRequired,
  adminEmail: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => {
  const adminEmail = () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('profile'));
      const email = _.get(data, 'email');
      return email;
    } catch (error) {
      return '';
    }
  };

  return {
    businessInfo: _.get(api, `${c.GET_BUSINESS_INFO}.item`) || {},
    businessTransactionHistoryList:
      _.get(api, `${c.GET_BUSINESS_TRANSACTION_HISTORY_LIST}.list`) || [],
    isLoading: api.loading.indexOf(c.GET_BUSINESS_INFO) > -1,
    businessFixTaxList: _.get(api, `${c.GET_BUSINESS_FIX_TAX_LIST}.list`) || [],
    otherFeeList: _.get(api, `${c.GET_OTHER_FEE_LIST}.list`) || [],
    token: sessionStorage.getItem('token') || '',
    adminEmail: adminEmail() || '',
  };
};

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(BusinessTaxContent);
